if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      _cpInit = false;
      _cpNS = '';
      _cpRecalc = null;
      _cpVariantHandler = null;

      _colorProductDataPromise = null;
      _colorProductDataUrl = '';
      _colorMediaRequestToken = 0;

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        // Edge finish supports two compatible combinations:
        // Fingersafe + Sanded OR Fingersafe + Polished.
        // Sanded and Polished cannot be selected together.
        $('.finishlabel').off('click.edgeFinish').on('click.edgeFinish', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const $input = $(this).find('input[name="finish"]');
          if (!$input.length) return;

          const value = String($input.val() || '').toLowerCase();
          const willCheck = !$input.prop('checked');

          if (willCheck) {
            if (value === 'polished') {
              $('input[name="finish"][value="Sanded"]').prop('checked', false);
            } else if (value === 'sanded') {
              $('input[name="finish"][value="Polished"]').prop('checked', false);
            }
          }

          $input.prop('checked', willCheck).trigger('change');

          $('.finishlabel').removeClass('selected');
          $('input[name="finish"]:checked').closest('.finishlabel').addClass('selected');
        });

      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.querySelectorAll('#length[data-sheet-dimension-input], #width[data-sheet-dimension-input]')
          .forEach((input) => input.removeAttribute('max'));

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        if($('.custom-product-template').length > 0){
           this.updateCustomProduct();
        }else{
          $('.qty__input').on('input change',function(){

            $('#varquantity').val($(this).val());
          })
        }

      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        if (this._cpNS) $(document).off(this._cpNS);
        if (this._cpVariantHandler) {
          ['variant:change','variant:changed','theme:variant:change','product:variant-change']
            .forEach(evt => document.removeEventListener(evt, this._cpVariantHandler, true));
          this._cpVariantHandler = null;
        }
        if (this._cpMO) { try { this._cpMO.disconnect(); } catch(e) {} this._cpMO = null; }

        this._cpInit = false;
        this._cpRecalc = null;
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        if($(target).parents('.var-grid').length > 0){
          return;
        }

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
            if($('.custom-product-template').length > 0){
              this.updateCustomProduct();
            }
          })
          .then(() => {

            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
            if($('.custom-product-template').length > 0){
               this.updateCustomProduct();
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {

        }
      }

      getSelectedColorValue() {
        const variantSelects = this.querySelector('variant-selects');
        if (!variantSelects) return null;

        const controls = variantSelects.querySelectorAll(
          'select[name^="options["], input[name^="options["]'
        );

        for (const control of controls) {
          const name = control.getAttribute('name') || '';
          const match = name.match(/^options\[(.+)\]$/);
          if (!match) continue;

          const optionName = String(match[1]).trim().toLowerCase();
          if (optionName !== 'color' && optionName !== 'colour') continue;

          if (control.tagName === 'SELECT') {
            return control.value || null;
          }

          if ((control.type === 'radio' || control.type === 'checkbox') && control.checked) {
            return control.value || null;
          }
        }

        return null;
      }

      getColorProductData(productUrl) {
        if (!productUrl) return Promise.resolve(null);

        const cleanUrl = String(productUrl).split('?')[0].replace(/\.js$/i, '').replace(/\/$/, '');
        const jsonUrl = `${cleanUrl}.js`;

        if (this._colorProductDataPromise && this._colorProductDataUrl === jsonUrl) {
          return this._colorProductDataPromise;
        }

        this._colorProductDataUrl = jsonUrl;
        this._colorProductDataPromise = fetch(jsonUrl, {
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Unable to load product JSON (${response.status})`);
            }
            return response.json();
          })
          .catch((error) => {
            console.warn('[Color media] Product JSON load failed:', error);
            this._colorProductDataPromise = null;
            return null;
          });

        return this._colorProductDataPromise;
      }

      getColorOptionIndex(productData) {
        if (!productData || !Array.isArray(productData.options)) return -1;

        return productData.options.findIndex((option) => {
          const name = typeof option === 'string'
            ? option
            : (option?.name || option?.title || '');

          const normalized = String(name).trim().toLowerCase();
          return normalized === 'color' || normalized === 'colour';
        });
      }

      getVariantMediaInfo(variant) {
        if (!variant) return { mediaId: null, imageUrl: null };

        const featuredMedia = variant.featured_media || null;
        const featuredImage = variant.featured_image || variant.image || null;

        let mediaId = featuredMedia?.id || null;
        let imageUrl =
          featuredMedia?.preview_image?.src ||
          featuredMedia?.preview_image?.url ||
          featuredMedia?.src ||
          featuredMedia?.url ||
          null;

        if (!imageUrl && featuredImage) {
          if (typeof featuredImage === 'string') {
            imageUrl = featuredImage;
          } else {
            mediaId = mediaId || featuredImage.id || null;
            imageUrl =
              featuredImage.src ||
              featuredImage.url ||
              featuredImage.original_src ||
              null;
          }
        }

        return { mediaId, imageUrl };
      }

      normalizeMediaImageUrl(url) {
        if (!url) return '';

        try {
          const parsed = new URL(url, window.location.origin);
          return decodeURIComponent(parsed.pathname)
            .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '')
            .toLowerCase();
        } catch (e) {
          return String(url)
            .split('?')[0]
            .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '')
            .toLowerCase();
        }
      }

      findMediaIdByImageUrl(imageUrl, html) {
        const wanted = this.normalizeMediaImageUrl(imageUrl);
        if (!wanted) return null;

        const roots = [this, html].filter(Boolean);

        for (const root of roots) {
          const mediaItems = root.querySelectorAll?.('[data-media-id]') || [];

          for (const item of mediaItems) {
            const images = item.querySelectorAll?.('img') || [];

            for (const image of images) {
              const candidates = [
                image.currentSrc,
                image.src,
                image.getAttribute('src'),
                image.getAttribute('data-src')
              ].filter(Boolean);

              if (candidates.some((candidate) => this.normalizeMediaImageUrl(candidate) === wanted)) {
                const rawMediaId = item.getAttribute('data-media-id') || item.dataset?.mediaId || '';
                const numericMatch = String(rawMediaId).match(/(\d+)$/);
                return numericMatch ? numericMatch[1] : rawMediaId || null;
              }
            }
          }
        }

        return null;
      }

      slideToMedia(mediaId) {
        if (!mediaId) return;

        const mediaIdString = String(mediaId);

        let slide = document.querySelector(
          `.product-media-slider .swiper-slide[data-mediaid="${mediaIdString}"]`
        );

        if (!slide) {
          const slides = document.querySelectorAll(
            '.product-media-slider .swiper-slide[data-mediaid]'
          );

          slide = Array.from(slides).find((item) => {
            const value = String(item.getAttribute('data-mediaid') || '');
            return value === mediaIdString || value.endsWith(`-${mediaIdString}`);
          });
        }

        if (!slide) {
          console.warn('[Color media] Matching Swiper slide not found for media:', mediaId);
          return;
        }

        const index = slide.getAttribute('data-index');
        if (index === null || index === undefined || index === '') return;

        document.dispatchEvent(
          new CustomEvent('changeSlide', {
            detail: {
              data: index
            }
          })
        );
      }

      async updateMediaForSelectedColor(productUrl, html) {
        const selectedColor = this.getSelectedColorValue();
        if (!selectedColor) return false;

        const requestToken = ++this._colorMediaRequestToken;
        const productData = await this.getColorProductData(productUrl);

        if (requestToken !== this._colorMediaRequestToken) return true;
        if (!productData) return false;

        const currentColor = this.getSelectedColorValue();
        if (
          !currentColor ||
          String(currentColor).trim().toLowerCase() !==
            String(selectedColor).trim().toLowerCase()
        ) {
          return true;
        }

        const colorOptionIndex = this.getColorOptionIndex(productData);
        if (colorOptionIndex < 0 || !Array.isArray(productData.variants)) {
          return false;
        }

        const normalizedSelectedColor = String(selectedColor).trim().toLowerCase();

        const matchingVariants = productData.variants.filter((variant) => {
          const options = Array.isArray(variant.options) ? variant.options : [];
          const value = options[colorOptionIndex];

          return (
            value !== undefined &&
            value !== null &&
            String(value).trim().toLowerCase() === normalizedSelectedColor
          );
        });

        if (!matchingVariants.length) {
          console.warn('[Color media] No variant found for selected color:', selectedColor);
          return false;
        }

        const hasMedia = (variant) => {
          const info = this.getVariantMediaInfo(variant);
          return Boolean(info.mediaId || info.imageUrl);
        };

        const mediaVariant = matchingVariants.find((variant) => hasMedia(variant));

        if (!mediaVariant) {
          console.warn('[Color media] Selected color has no assigned variant media:', selectedColor);
          return false;
        }

        const mediaInfo = this.getVariantMediaInfo(mediaVariant);

        let mediaId = mediaInfo.mediaId;
        if (!mediaId && mediaInfo.imageUrl) {
          mediaId = this.findMediaIdByImageUrl(mediaInfo.imageUrl, html);
        }

        if (!mediaId) {
          console.warn('[Color media] Could not resolve media ID for color:', selectedColor);
          return false;
        }

        if (requestToken !== this._colorMediaRequestToken) return true;

        this.updateMedia(html, mediaId);
        this.slideToMedia(mediaId);

        return true;
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          const selectedColor = this.getSelectedColorValue();

          if (selectedColor) {
            this.updateMediaForSelectedColor(productUrl, html).then((handled) => {

              if (!handled && variant?.featured_media?.id) {
                this.updateMedia(html, variant.featured_media.id);
                this.slideToMedia(variant.featured_media.id);
              }
            });
          } else if (variant?.featured_media?.id) {

            this.updateMedia(html, variant.featured_media.id);
            this.slideToMedia(variant.featured_media.id);
          }

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;

              if (id === 'Catalog-Pricing') {
                ['data-variant-id', 'data-quantity-min', 'data-quantity-increment', 'data-quantity-max'].forEach((attribute) => {
                  const value = source.getAttribute(attribute);
                  if (value === null) destination.removeAttribute(attribute);
                  else destination.setAttribute(attribute, value);
                });
              }

              destination.classList.toggle('hidden', shouldHide(source));
            }

          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Catalog-Pricing');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
          window.PlasticareCatalogPricing?.refresh(this);

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );
          if($('.custom-product-template').length > 0){
           this.updateCustomProduct();
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Catalog-Pricing', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);

                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      updateCustomProduct() {

        const getCatalogPriceForQuantity = (fallbackPrice, quantity = 1) => {
          const slot = this.querySelector('[data-catalog-pricing-slot]');
          const table = slot?.querySelector('[data-catalog-pricing-table]');
          if (!table) return Number(fallbackPrice) || 0;

          const qty = Math.max(1, Number.parseInt(quantity, 10) || 1);
          const rows = [...table.querySelectorAll('[data-catalog-price-row]')];
          const row = rows.find((item) => {
            const min = Math.max(1, Number.parseInt(item.dataset.min, 10) || 1);
            const max = item.dataset.max ? Number.parseInt(item.dataset.max, 10) : Number.MAX_SAFE_INTEGER;
            return qty >= min && qty <= max;
          });

          const cents = Number(row?.dataset.priceCents);
          return Number.isFinite(cents) ? cents / 100 : (Number(fallbackPrice) || 0);
        };

        if (this._cpInit && typeof this._cpRecalc === 'function') {
          try { this._cpRecalc(); } catch(e) { console.warn(e); }
          return;
        }

        this._cpInit = true;
        this._cpNS = `.cp-${this.sectionId || this.dataset.section || Math.random().toString(36).slice(2)}`;

        const isSignGradePolycarbonate = () => {
          return document.body.className.includes('sign-grade-polycarbonate') ||
            (document.querySelector('select[name="options[Roll Width ]"]') && document.querySelector('#length') && document.querySelector('#width'));
        };

        if (isSignGradePolycarbonate()) {
          const ns = this._cpNS;

          const ALLOWED_LENGTHS = [12,18,24,36,48,60,72,84,96,108,120,132,144,156,168,180,192,204,216,228,240];
          const MIN_LEN = 12;
          const MAX_LEN = 240;

          const $len = $('#length');
          const $wid = $('#width');

          const ensureMsgEl = () => {
            let $msg = $('#sgp-msg');
            if (!$msg.length) {
              $msg = $('<div id="sgp-msg" class="sgp-msg" style="margin-top:10px;"></div>');
              $('#calc-panel').after($msg);
            }
            return $msg;
          };

          const parseInchesFromOption = (val) => {
            if (!val) return 0;
            const m = String(val).match(/(\d+(\.\d+)?)/);
            return m ? parseFloat(m[1]) : 0;
          };

          const getSelectedRollWidth = () => {
            const $roll = $('select[name="options[Roll Width ]"]');
            if (!$roll.length) return 0;
            return parseInchesFromOption($roll.val());
          };

          const getVariantUnitPricePerFoot = (quantity = 1) => {
            let basePrice = 0;
            const dp = Number($('.main_var_price').attr('data-price'));
            if (isFinite(dp) && dp > 0) basePrice = dp / 100;

            if (!basePrice) {
              const tag = document.querySelector('variant-selects [data-selected-variant]');
              if (tag && tag.textContent.trim()) {
                try {
                  const v = JSON.parse(tag.textContent.trim());
                  if (v && typeof v.price === 'number') basePrice = v.price / 100;
                } catch(e) {}
              }
            }
            return getCatalogPriceForQuantity(basePrice, quantity);
          };

          const money = (n) => {
            try {
              if (window.Shopify && typeof Shopify.formatMoney === 'function') {
                return Shopify.formatMoney(Math.round(n * 100), (window.theme && theme.moneyFormat) || "${{amount}}");
              }
            } catch(e) {}
            return (n || 0).toLocaleString(undefined, { style: 'currency', currency: (Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
          };

          const roundUpLength = (val) => {
            let n = parseFloat(val);
            if (!isFinite(n) || n <= 0) return 0;
            if (n < MIN_LEN) return MIN_LEN;
            for (let i = 0; i < ALLOWED_LENGTHS.length; i++) {
              if (n <= ALLOWED_LENGTHS[i]) return ALLOWED_LENGTHS[i];
            }
            return n;
          };

          const setAddToCartEnabled = (enabled) => {
            const $btn = $(`#ProductSubmitButton-${this.sectionId}, #ProductSubmitButton-${this.dataset.section}`).first();
            if ($btn.length) {
              $btn.prop('disabled', !enabled);
              $btn.toggleClass('disabled', !enabled);
            }
          };

          const upsertLineItemProperty = (name, value) => {
            const $form = $(`#product-form-${this.dataset.section}`);
            if (!$form.length) return;

            const fieldName = `properties[${name}]`;
            let $input = $form.find(`input[name="${fieldName}"]`);
            if (!$input.length) {
              $input = $(`<input type="hidden" name="${fieldName}" />`);
              $form.append($input);
            }
            $input.val(value == null ? '' : String(value));
          };

          const enforceWidthLimit = () => {
            const rollW = getSelectedRollWidth();
            if (!rollW) return;

            const w = parseFloat($wid.val());
            if (isFinite(w) && w > rollW) {
              $wid.val(rollW);
              const el = $wid[0];
              if (el && el.setCustomValidity) {
                el.setCustomValidity(`Max width for selected roll is ${rollW}"`);
                if (el.reportValidity) el.reportValidity();
                setTimeout(() => el.setCustomValidity(''), 1000);
              }
            }
          };

          const recalcSGP = () => {
            const $msg = ensureMsgEl();
            $msg.empty().removeClass('error');

            enforceWidthLimit();

            const rollW = getSelectedRollWidth();
            const Lraw = parseFloat($len.val()) || 0;
            const Wraw = parseFloat($wid.val()) || 0;

            if (!(Lraw > 0 && Wraw > 0 && rollW > 0)) {
              $('#unit-price').text(money(getVariantUnitPricePerFoot()));
              $('#sqft').text('0.00');
              $('#total').text('$0.00');
              $('#totalPrice').html('$0.00').attr('data-total', 0);
              setAddToCartEnabled(false);
              return;
            }

            if (Wraw > rollW) {
              $msg.text(`Entered width (${Wraw}") cannot be greater than selected roll width (${rollW}").`).addClass('error');
              setAddToCartEnabled(false);
              return;
            }

            const billableLenIn = roundUpLength(Lraw);

            if (billableLenIn > MAX_LEN) {
              $msg.html(`Length over ${MAX_LEN}" cannot be ordered online. Please call us to place the order.`);
              $msg.addClass('error');
              setAddToCartEnabled(false);
              return;
            }

            const qty = parseInt($('.qty__input').val(), 10) || 1;
            const unitPrice = getVariantUnitPricePerFoot(qty);

            const billableFeet = billableLenIn / 12;
            const sqft = (Wraw * billableLenIn) / 144;

            var total = unitPrice * billableFeet * qty;
            if(Lraw >= 175 && Lraw < 220){
              total = total + 100;
            }
            if(Lraw >= 220 && Lraw <= 240){
              total = total + 200;
            }

            $('#unit-price').text(money(unitPrice));
            $('#sqft').text(sqft.toFixed(2));
            $('#total').text(money(total));
            $('#totalPrice').html(money(total)).attr('data-total', total);
            $('.main_var_price').html(money(total)).attr('data-total', total);

            upsertLineItemProperty('Cut Width', Wraw);
            upsertLineItemProperty('Cut Length', Lraw);

            setAddToCartEnabled(true);
          };

          this._cpRecalc = recalcSGP;

          $(document)
            .off(`input${ns} change${ns} blur${ns}`, '#length, #width')
            .on(`input${ns} change${ns} blur${ns}`, '#length, #width', recalcSGP);

          $(document)
            .off(`change${ns}`, 'select[name="options[Roll Width ]"], select[name="options[Color]"]')
            .on(`change${ns}`, 'select[name="options[Roll Width ]"], select[name="options[Color]"]', recalcSGP);

          this._cpVariantHandler = () => recalcSGP();
          ['variant:change','variant:changed','theme:variant:change','product:variant-change']
            .forEach(evt => document.addEventListener(evt, this._cpVariantHandler, true));

          const $tag = $('[data-selected-variant]').first();
          if ($tag.length && 'MutationObserver' in window) {
            try {
              this._cpMO && this._cpMO.disconnect();
              this._cpMO = new MutationObserver(() => recalcSGP());
              this._cpMO.observe($tag[0], { childList: true, characterData: true, subtree: true });
            } catch(e) {}
          }

          $('#length').attr({ min: 0, step: 0.01, inputmode: 'decimal' });
          $('#width').attr({ min: 0, step: 0.01, inputmode: 'decimal' });

          $('.qty__input').off(`input${ns} change${ns}`).on(`input${ns} change${ns}`, function () {
            recalcSGP();
            $('#varquantity').val($(this).val());
          });

          recalcSGP();
          return;
        }

        const isTwinwallCorrugated = () => {
          return document.body.className.includes('twinwall-polycarbonate-co') ||
            (document.querySelector('select[name="options[Width]"]') && document.querySelector('#length') && document.querySelector('#width'));
        };
        console.log('isTwinwallCorrugated =  ' + isTwinwallCorrugated)
        if (isTwinwallCorrugated()) {
          const ns = this._cpNS;

          const ALLOWED_LEN_IN = [96, 120, 144, 192, 288];
          const MIN_LEN_IN = 96;
          const MAX_LEN_IN = 288;

          const $len = $('#length');
          const $wid = $('#width');

          const ensureMsgEl = () => {
            let $msg = $('#twc-msg');
            if (!$msg.length) {
              $msg = $('<div id="twc-msg" class="sgp-msg" style="margin-top:10px;"></div>');
              $('#calc-panel').after($msg);
            }
            return $msg;
          };

          const parseInchesFromOption = (val) => {
            if (!val) return 0;
            const m = String(val).match(/(\d+(\.\d+)?)/);
            return m ? parseFloat(m[1]) : 0;
          };

          const getSelectedWidthLimit = () => {
            const $w = $('select[name="options[Width]"]');
            if (!$w.length) return 0;
            return parseInchesFromOption($w.val());
          };

          const getVariantUnitPricePerFoot = (quantity = 1) => {
            let basePrice = 0;
            const dp = Number($('.main_var_price').attr('data-price'));
            if (isFinite(dp) && dp > 0) basePrice = dp / 100;

            if (!basePrice) {
              const tag = document.querySelector('variant-selects [data-selected-variant]');
              if (tag && tag.textContent.trim()) {
                try {
                  const v = JSON.parse(tag.textContent.trim());
                  if (v && typeof v.price === 'number') basePrice = v.price / 100;
                } catch(e) {}
              }
            }
            return getCatalogPriceForQuantity(basePrice, quantity);
          };

          const money = (n) => {
            try {
              if (window.Shopify && typeof Shopify.formatMoney === 'function') {
                return Shopify.formatMoney(Math.round(n * 100), (window.theme && theme.moneyFormat) || "${{amount}}");
              }
            } catch(e) {}
            return (n || 0).toLocaleString(undefined, { style: 'currency', currency: (Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
          };

          const roundUpLenIn = (val) => {
            let n = parseFloat(val);
            if (!isFinite(n) || n <= 0) return 0;
            if (n < MIN_LEN_IN) return MIN_LEN_IN;
            for (let i = 0; i < ALLOWED_LEN_IN.length; i++) {
              if (n <= ALLOWED_LEN_IN[i]) return ALLOWED_LEN_IN[i];
            }
            return n;
          };

          const setAddToCartEnabled = (enabled) => {
            const $btn = $(`#ProductSubmitButton-${this.sectionId}, #ProductSubmitButton-${this.dataset.section}`).first();
            if ($btn.length) {
              $btn.prop('disabled', !enabled);
              $btn.toggleClass('disabled', !enabled);
            }
          };

          const upsertLineItemProperty = (name, value) => {
            const $form = $(`#product-form-${this.dataset.section}`);
            if (!$form.length) return;

            const fieldName = `properties[${name}]`;
            let $input = $form.find(`input[name="${fieldName}"]`);
            if (!$input.length) {
              $input = $(`<input type="hidden" name="${fieldName}" />`);
              $form.append($input);
            }
            $input.val(value == null ? '' : String(value));
          };

          const enforceWidthLimit = () => {
            const limit = getSelectedWidthLimit();
            if (!limit) return;

            $wid.attr({ max: limit, min: 0, step: 0.01, inputmode: 'decimal' });
            const w = parseFloat($wid.val());
            if (isFinite(w) && w > limit) {
              $wid.val(limit);
              const el = $wid[0];
              if (el && el.setCustomValidity) {
                el.setCustomValidity(`Max width for selected width is ${limit}"`);
                if (el.reportValidity) el.reportValidity();
                setTimeout(() => el.setCustomValidity(''), 1000);
              }
            }
          };

          const recalcTWC = () => {
            const $msg = ensureMsgEl();
            $msg.empty().removeClass('error');

            enforceWidthLimit();

            const widthLimit = getSelectedWidthLimit();
            const Lraw = parseFloat($len.val()) || 0;
            const Wraw = parseFloat($wid.val()) || 0;

            $len.attr({ min: 0, max: MAX_LEN_IN, step: 0.01, inputmode: 'decimal' });

            if (!(Lraw > 0 && Wraw > 0 && widthLimit > 0)) {
              const unit = getVariantUnitPricePerFoot();
              $('#unit-price').text(money(unit));
              $('#sqft').text('0.00');
              $('#total').text('$0.00');
              $('#totalPrice').html('$0.00').attr('data-total', 0);
              $('.main_var_price').html('$0.00').attr('data-total', 0);
              setAddToCartEnabled(false);
              return;
            }

            if (Wraw > widthLimit) {
              $msg.text(`Entered width (${Wraw}") cannot be greater than selected width (${widthLimit}").`).addClass('error');
              setAddToCartEnabled(false);
              return;
            }

            const billableLenIn = roundUpLenIn(Lraw);

            if (billableLenIn > MAX_LEN_IN) {
              $msg.html(`Length over 24ft (288") cannot be ordered online. Please call us to place the order.`);
              $msg.addClass('error');
              setAddToCartEnabled(false);
              return;
            }

            const qty = parseInt($('.qty__input').val(), 10) || 1;
            const unitPrice = getVariantUnitPricePerFoot(qty);

            const billableFeet = billableLenIn / 12;
            const sqft = (Wraw * billableLenIn) / 144;

            const total = unitPrice * billableFeet * qty;

            $('#unit-price').text(money(unitPrice));
            $('#sqft').text(sqft.toFixed(2));
            $('#total').text(money(total));
            $('#totalPrice').html(money(total)).attr('data-total', total);
            $('.main_var_price').html(money(total)).attr('data-total', total);

            upsertLineItemProperty('Cut Width', Wraw);
            upsertLineItemProperty('Cut Length', Lraw);
            upsertLineItemProperty('Selected Width', widthLimit + '"');
            upsertLineItemProperty('Billable Length', (billableFeet % 1 === 0 ? billableFeet.toFixed(0) : billableFeet.toFixed(2)) + ' ft');

            setAddToCartEnabled(true);
          };

          this._cpRecalc = recalcTWC;

          $(document)
            .off(`input${ns} change${ns} blur${ns}`, '#length, #width')
            .on(`input${ns} change${ns} blur${ns}`, '#length, #width', recalcTWC);

          $(document)
            .off(`change${ns}`, 'select[name="options[Width]"], select[name="options[Color]"], select[name="options[Thickness]"]')
            .on(`change${ns}`, 'select[name="options[Width]"], select[name="options[Color]"], select[name="options[Thickness]"]', recalcTWC);

          this._cpVariantHandler = () => recalcTWC();
          ['variant:change','variant:changed','theme:variant:change','product:variant-change']
            .forEach(evt => document.addEventListener(evt, this._cpVariantHandler, true));

          const $tag = $('[data-selected-variant]').first();
          if ($tag.length && 'MutationObserver' in window) {
            try {
              this._cpMO && this._cpMO.disconnect();
              this._cpMO = new MutationObserver(() => recalcTWC());
              this._cpMO.observe($tag[0], { childList: true, characterData: true, subtree: true });
            } catch(e) {}
          }

          $('.qty__input').off(`input${ns} change${ns}`).on(`input${ns} change${ns}`, function () {
            recalcTWC();
            $('#varquantity').val($(this).val());
          });

          recalcTWC();
          return;
        }

        var ROUND_SET       = window.CP_CONF.ROUND_SET;
        var MAX_L           = window.CP_CONF.MAX_L;
        var MAX_W           = window.CP_CONF.MAX_W;

        var ALLOW_DIMENSION_SWAP = $('#length[data-sheet-dimension-input]').length > 0 && $('#width[data-sheet-dimension-input]').length > 0;
        var MAX_LONG_SIDE = Math.max(Number(MAX_L) || 0, Number(MAX_W) || 0);
        var MAX_SHORT_SIDE = Math.min(Number(MAX_L) || 0, Number(MAX_W) || 0);
        var HOLE_PRICE      = Number(window.CP_CONF.HOLE_PRICE || 0);
        var ROUNDING_OFFSET = Number(window.CP_CONF.ROUNDING_OFFSET || 0);

        var EDGE_RATES      = window.CP_CONF.EDGE_RATES || {};
        var EDGE_COMBO_RATES = window.CP_CONF.EDGE_COMBO_RATES || {};
        var RADIUS_FLAT     = Number(window.CP_CONF.RADIUS_FLAT || 0);

        var MIN_CHARGES = window.CP_CONF.MIN_CHARGES || {};
        var MIN_CHARGE_TIERS = window.CP_CONF.MIN_CHARGE_TIERS || {};

        if (window.CP_CONF.POLISHED_EDGE_RATE !== undefined) {
          EDGE_RATES.Polished = Number(window.CP_CONF.POLISHED_EDGE_RATE || 0);
        }

        function normalizeCalculatorQuantity(quantity) {
          quantity = parseInt(quantity, 10);
          return isFinite(quantity) && quantity > 0 ? quantity : 1;
        }

        function getMinimumCharge(type, quantity) {
          quantity = normalizeCalculatorQuantity(quantity);

          if (typeof window.CP_CONF.getMinimumCharge === 'function') {
            return Number(window.CP_CONF.getMinimumCharge(type, quantity) || 0);
          }

          var tiers = MIN_CHARGE_TIERS[type];
          if (tiers) {
            var tier = quantity >= 3 ? 3 : quantity;
            return Number(tiers[tier] || 0);
          }

          return Number(MIN_CHARGES[type] || 0);
        }

        function getHighestSelectedMinimum(selectedTypes, quantity) {
          quantity = normalizeCalculatorQuantity(quantity);

          if (typeof window.CP_CONF.getHighestSelectedMinimum === 'function') {
            return Number(window.CP_CONF.getHighestSelectedMinimum(selectedTypes, quantity) || 0);
          }

          var highestMinimum = 0;
          (selectedTypes || []).forEach(function(type) {
            if (!type) return;
            highestMinimum = Math.max(highestMinimum, getMinimumCharge(type, quantity));
          });

          return highestMinimum;
        }

        function applyNonStackingMinimum(rawAdditionalPerUnit, quantity, selectedTypes) {
          quantity = normalizeCalculatorQuantity(quantity);
          rawAdditionalPerUnit = Number(rawAdditionalPerUnit || 0);

          if (typeof window.CP_CONF.applyNonStackingMinimum === 'function') {
            var configuredResult = window.CP_CONF.applyNonStackingMinimum(
              rawAdditionalPerUnit,
              quantity,
              selectedTypes
            ) || {};

            var configuredLineTotal = Number(configuredResult.lineTotal);
            var configuredPerUnit = Number(configuredResult.perUnit);

            if (isFinite(configuredLineTotal) && configuredLineTotal >= 0 &&
                isFinite(configuredPerUnit) && configuredPerUnit >= 0) {
              return {
                perUnit: configuredPerUnit,
                lineTotal: configuredLineTotal,
                rawLineTotal: Number(configuredResult.rawLineTotal || rawAdditionalPerUnit * quantity),
                minimum: Number(configuredResult.minimum || 0),
                minimumApplied: Boolean(configuredResult.minimumApplied)
              };
            }
          }

          var rawLineTotal = rawAdditionalPerUnit * quantity;
          var highestMinimum = getHighestSelectedMinimum(selectedTypes, quantity);
          var adjustedLineTotal = Math.max(rawLineTotal, highestMinimum);

          return {
            perUnit: adjustedLineTotal / quantity,
            lineTotal: adjustedLineTotal,
            rawLineTotal: rawLineTotal,
            minimum: highestMinimum,
            minimumApplied: highestMinimum > rawLineTotal
          };
        }

        function roundUpToSet(val, set, cap, offset){
          var n = parseFloat(val);
          if (!isFinite(n) || n <= 0) return 0;

          cap = Number(cap) || 0;
          offset = Number(offset);
          if (!isFinite(offset) || offset < 0) offset = 0;

          var sizes = Array.isArray(set) ? set
            .map(function(size){ return Number(size); })
            .filter(function(size){ return isFinite(size) && size > 0; })
            .sort(function(a, b){ return a - b; }) : [];

          if (!sizes.length) return cap > 0 ? Math.min(n, cap) : n;

          // The value entered by the customer is the finished dimension. The
          // rounding offset is the material/cut allowance. Example: with a 36"
          // stock breakpoint and a 0.124" allowance, the usable limit is
          // 35.876". Therefore 35.876" is billed at 36", while anything above
          // 35.876" (including 36") moves to the next configured breakpoint.
          var epsilon = 1e-6;
          var requested = cap > 0 ? Math.min(n, cap) : n;

          // IMPORTANT: `cap` limits what the customer may ENTER, but it must
          // not limit the configured billing ladder. Plasticare intentionally
          // uses billing breakpoints such as 48.01 while the physical maximum
          // input is 48. That tiny overage is a pricing/rounding allowance, not
          // an oversize part. Therefore a 36 x 48 part can correctly round to
          // 48.01 x 48.01 instead of falling back to 35.876 on the short side.
          for (var i = 0; i < sizes.length; i++){
            var stockSize = sizes[i];
            var usableLimit = Math.max(0, stockSize - offset);
            if (requested <= usableLimit + epsilon) return stockSize;
          }

          // If the entered dimension is valid but sits above the final usable
          // breakpoint, keep the last configured billing size. Input-size
          // validation is handled separately by getDimensionEnvelopeError().
          return sizes[sizes.length - 1] || requested;
        }

        function money(n){
          try{
            if (window.Shopify && typeof Shopify.formatMoney === 'function'){
              return Shopify.formatMoney(Math.round(n*100), (window.theme && theme.moneyFormat) || "${{amount}}");
            }
          }catch(e){}
          return (n || 0).toLocaleString(undefined, {style:'currency', currency:(Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'});
        }

        function getUnitPrice(quantity){
          var v = Number($('.main_var_price').attr('data-price'));
          var basePrice = Number.isFinite(v) ? v / 100 : 0;
          return getCatalogPriceForQuantity(basePrice, quantity || 1);
        }

        function pokeValidity($el, msg){
          var el = $el[0];
          if (!el) return;
          if (el.setCustomValidity){
            el.setCustomValidity(msg||'');
            if (msg && el.reportValidity) el.reportValidity();
            setTimeout(function(){ el.setCustomValidity(''); }, 1000);
          }
        }

        function clamp($el, min, max, label){
          var v = $el.val();
          if (v && /[^\d.]/.test(v)){
            v = v.replace(/[^\d.]/g,'');
            $el.val(v);
          }
          var n = parseFloat(v);
          if (!isFinite(n)) return;
          if (n < min){ $el.val(min); pokeValidity($el, label+' min is '+min+'"'); }
          if (n > max){ $el.val(max); pokeValidity($el, label+' max is '+max+'"'); }
        }
        function getOrientedDimensions(length, width){
          var L = parseFloat(length) || 0;
          var W = parseFloat(width) || 0;
          return { longSide: Math.max(L, W), shortSide: Math.min(L, W) };
        }

        function getOversizeSupportMessage(){
          return 'These dimensions do not fit within a 48" x 96" sheet. For sizes larger than 48" x 96", please call 303-781-1171.';
        }

        function ensureDimensionEnvelopeMessage(){
          var $message = $('#dimension-envelope-error');
          if ($message.length) return $message;

          $message = $('<div id="dimension-envelope-error" class="dimension-envelope-error" role="alert" aria-live="assertive"></div>');
          var $lengthRow = $('#length').closest('.var-grid');
          var $widthRow = $('#width').closest('.var-grid');
          var $targetRow = $widthRow.length ? $widthRow : $lengthRow;
          if ($targetRow.length) $targetRow.after($message);
          return $message;
        }

        function showDimensionEnvelopeMessage(message){
          var $message = ensureDimensionEnvelopeMessage();
          $message.text(message || getOversizeSupportMessage()).addClass('is-visible');
        }

        function hideDimensionEnvelopeMessage(){
          $('#dimension-envelope-error').removeClass('is-visible').empty();
        }

        function getDimensionEnvelopeError(length, width){
          if (!ALLOW_DIMENSION_SWAP) return '';
          var dims = getOrientedDimensions(length, width);
          if (!(dims.longSide > 0 && dims.shortSide > 0)) return '';
          if (dims.longSide > MAX_LONG_SIDE || dims.shortSide > MAX_SHORT_SIDE) {
            return getOversizeSupportMessage();
          }
          return '';
        }

        function enforceLimits(){
          if (ALLOW_DIMENSION_SWAP) {

            $('#length, #width').removeAttr('max');
            var dimensionError = getDimensionEnvelopeError($('#length').val(), $('#width').val());
            var lengthEl = $('#length')[0];
            var widthEl = $('#width')[0];

            if (dimensionError) {
              showDimensionEnvelopeMessage(dimensionError);
              if (lengthEl && lengthEl.setCustomValidity) lengthEl.setCustomValidity(dimensionError);
              if (widthEl && widthEl.setCustomValidity) widthEl.setCustomValidity(dimensionError);
            } else {
              hideDimensionEnvelopeMessage();
              if (lengthEl && lengthEl.setCustomValidity) lengthEl.setCustomValidity('');
              if (widthEl && widthEl.setCustomValidity) widthEl.setCustomValidity('');
            }
          } else {
            clamp($('#length'), 0, MAX_L, 'Length');
            clamp($('#width'), 0, MAX_W, 'Width');
          }
        }

        function holesEnabled(){ return ($('#drill-holes').val() === 'yes'); }

        function toggleHoleFields(){
          var $holeSize  = $('#hole-size');
          var $holePos   = $('#hole-position');
          var $holeCount = $('#num-holes');
          var $file      = $('#special-file');
          var on = holesEnabled();
          [$holeSize, $holePos, $holeCount, $file].forEach(function($el){
            var $row = $el.closest('.var-grid');
            $row.toggle(on);
            $el.prop('disabled', !on).prop('required', on);
            if (!on) $el.val('');
          });
          if (!on) $('#num-holes').val('0');
        }

        const recalc = () => {
          enforceLimits();

          var L  = parseFloat($('#length').val()) || 0;
          var W  = parseFloat($('#width').val())  || 0;
          var qty = normalizeCalculatorQuantity($('.qty__input').val());

          var unitPrice = getUnitPrice(qty);
          var hasDims = L > 0 && W > 0;
          var dimensionError = hasDims ? getDimensionEnvelopeError(L, W) : '';

          if (dimensionError) {
            $('#unit-price').text(money(unitPrice));
            $('#sqft').text('0.00');
            $('#total').text('$0.00');
            $('#totalPrice').html('$0.00').attr('data-total', 0);
            return;
          }

          var sqFt = 0, material = unitPrice;

          var rL = 0, rW = 0;
          if (hasDims){
            if (ALLOW_DIMENSION_SWAP) {
              var oriented = getOrientedDimensions(L, W);
              rL = roundUpToSet(oriented.longSide, ROUND_SET, MAX_LONG_SIDE, ROUNDING_OFFSET);
              rW = roundUpToSet(oriented.shortSide, ROUND_SET, MAX_SHORT_SIDE, ROUNDING_OFFSET);
            } else {
              rL = roundUpToSet(L, ROUND_SET, MAX_L, ROUNDING_OFFSET);
              rW = roundUpToSet(W, ROUND_SET, MAX_W, ROUNDING_OFFSET);
            }
            sqFt = (rL>0 && rW>0) ? (rL*rW)/144 : 0;
            material = unitPrice * sqFt;
          } else {
            sqFt = 0;
            material = unitPrice;
          }

          var holes = holesEnabled() ? (parseInt($('#num-holes').val(), 10) || 0) : 0;
          var holesTotal = holes * HOLE_PRICE;

          var finishes = $('input[name="finish"]:checked').map(function(){
            return String($(this).val() || '').trim();
          }).get().filter(Boolean);
          var finishCombination = '';
          if (finishes.indexOf('Fingersafe') !== -1 && finishes.indexOf('Sanded') !== -1) {
            finishCombination = 'Fingersafe + Sanded';
          } else if (finishes.indexOf('Fingersafe') !== -1 && finishes.indexOf('Polished') !== -1) {
            finishCombination = 'Fingersafe + Polished';
          }

          var edgeRate = 0;
          if (finishCombination && EDGE_COMBO_RATES[finishCombination] !== null &&
              EDGE_COMBO_RATES[finishCombination] !== undefined &&
              String(EDGE_COMBO_RATES[finishCombination]).trim() !== '') {
            edgeRate = Number(EDGE_COMBO_RATES[finishCombination]);
          } else {
            edgeRate = finishes.reduce(function(totalRate, finishName){
              return totalRate + Number(EDGE_RATES[finishName] || 0);
            }, 0);
          }

          if (!isFinite(edgeRate)) edgeRate = 0;

          var perimeterInches = (Number($('#length').val()) + Number($('#width').val())) * 2;
          var edgeTotal = finishes.length ? edgeRate * perimeterInches : 0;

          var radiusSize = ($('#size').val() || '').trim();
          var radiusEnabled = radiusSize !== '';
          var radiusTotal = radiusEnabled ? RADIUS_FLAT : 0;

          var selectedMinimumTypes = [];

          if (radiusEnabled) selectedMinimumTypes.push('radius');
          if (holes > 0) selectedMinimumTypes.push('drill');
          if (finishCombination) {
            selectedMinimumTypes.push(finishCombination);
          } else {
            finishes.forEach(function(finishName){ selectedMinimumTypes.push(finishName); });
          }

          var rawAdditionalPerUnit = holesTotal + edgeTotal + radiusTotal;
          var minimumPricing = applyNonStackingMinimum(
            rawAdditionalPerUnit,
            qty,
            selectedMinimumTypes
          );

          var orgtotal = material + minimumPricing.perUnit;
          var total = orgtotal;

          $('#unit-price').text(money(unitPrice));
          $('#sqft').text(sqFt.toFixed(2));
          $('#total').text(money(total));
          $('#totalPrice').html(money(total));
          $('#totalPrice').attr('data-total',orgtotal);

          // Keep every visible calculator price surface in sync. Some custom
          // templates render .main_var_price while others render #totalPrice.
          // Do not overwrite data-price because that is the Shopify/catalog
          // base unit price used by getUnitPrice().
          $('.main_var_price').html(money(total)).attr('data-calculated-total', orgtotal);

          // Expose the billable dimensions for any pricing-table/UI listener
          // and for easier troubleshooting in the browser.
          $('#totalPrice')
            .attr('data-billable-length', rL || 0)
            .attr('data-billable-width', rW || 0);

          try {
            document.dispatchEvent(new CustomEvent('plasticare:calculator-price-updated', {
              detail: {
                requestedLength: L,
                requestedWidth: W,
                billableLength: rL,
                billableWidth: rW,
                squareFeet: sqFt,
                quantity: qty,
                total: total,
                totalBeforeQuantityPricing: orgtotal
              }
            }));
          } catch (e) {}
        };

        this._cpRecalc = recalc;

        const ns = this._cpNS;

        $(document)
          .off(`input${ns} change${ns} blur${ns}`, '#length, #width')
          .on(`input${ns} change${ns} blur${ns}`, '#length, #width', enforceLimits);

        $(document)
          .off(`input${ns} change${ns}`, '#length, #width, #num-holes, #hole-size, #hole-position')
          .on(`input${ns} change${ns}`, '#length, #width, #num-holes, #hole-size, #hole-position', recalc);

        $(document)
          .off(`change${ns}`, 'input[name="finish"]')
          .on(`change${ns}`, 'input[name="finish"]', recalc);

        $(document)
          .off(`change${ns}`, '#size')
          .on(`change${ns}`, '#size', recalc);

        $(document)
          .off(`change${ns}`, '#drill-holes')
          .on(`change${ns}`, '#drill-holes', function(){ toggleHoleFields(); recalc(); });

        this._cpVariantHandler = () => recalc();
        ['variant:change','variant:changed','theme:variant:change','product:variant-change']
          .forEach(evt => document.addEventListener(evt, this._cpVariantHandler, true));

        var $tag = $('[data-selected-variant]').first();
        if ($tag.length && 'MutationObserver' in window){
          try {
            this._cpMO && this._cpMO.disconnect();
            this._cpMO = new MutationObserver(() => recalc());
            this._cpMO.observe($tag[0], {childList:true, characterData:true, subtree:true});
          } catch(e) {}
        }

        if (ALLOW_DIMENSION_SWAP) {

          $('#length, #width')
            .removeAttr('max')
            .attr({min:0, step:0.01, inputmode:'decimal'});
        } else {
          $('#length').attr({min:0, max:MAX_L, step:0.01, inputmode:'decimal'});
          $('#width').attr({min:0, max:MAX_W, step:0.01, inputmode:'decimal'});
        }
        $('.qty__input').on('input change',function(){
          recalc();
          $('#varquantity').val($(this).val());
        });

        toggleHoleFields();
        enforceLimits();
        recalc();
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}



if($('.custom-product-template').length > 0){
 
  (function($){

    /* ---------- validation helpers ---------- */
    function clearError($el){
      $el.removeClass('input-error').attr('aria-invalid','false');
      var $row = $el.closest('.var-grid');
      $row.find('.field-error').remove();
    }

    function setError($el, msg){
      var $row = $el.closest('.var-grid');
      clearError($el);
      $el.addClass('input-error').attr('aria-invalid','true');
      $('<small class="field-error"/>').text(msg).appendTo($row);
    }

    function valOrEmpty(sel){ return ($(sel).val() || '').trim(); }
    function isPositiveNumber(v){ var n = parseFloat(v); return isFinite(n) && n > 0; }

    function holesEnabled(){ return $('#drill-holes').val() === 'yes'; } 

    /* ---------- validate the form ---------- */
    function validateProductForm(){
      var ok = true;

      var $len = $('#length');
      var $wid = $('#width');
      clearError($len); clearError($wid);

      var L = valOrEmpty('#length');
      var W = valOrEmpty('#width');

      if (!isPositiveNumber(L)){ setError($len, 'Please enter a valid length.'); ok = false; }
      if (!isPositiveNumber(W)){ setError($wid, 'Please enter a valid width.');  ok = false; }

      if (ok && $('#length[data-sheet-dimension-input]').length > 0 && $('#width[data-sheet-dimension-input]').length > 0) {
        var maxLength = Number(window.CP_CONF && window.CP_CONF.MAX_L) || 96;
        var maxWidth = Number(window.CP_CONF && window.CP_CONF.MAX_W) || 48;
        var maxLongSide = Math.max(maxLength, maxWidth);
        var maxShortSide = Math.min(maxLength, maxWidth);
        var numericLength = parseFloat(L);
        var numericWidth = parseFloat(W);
        var longSide = Math.max(numericLength, numericWidth);
        var shortSide = Math.min(numericLength, numericWidth);

        if (longSide > maxLongSide || shortSide > maxShortSide) {
          var message = 'These dimensions do not fit within a 48" x 96" sheet. For sizes larger than 48" x 96", please call 303-781-1171.';
          $len.addClass('input-error').attr('aria-invalid', 'true');
          $wid.addClass('input-error').attr('aria-invalid', 'true');
          var $dimensionMessage = $('#dimension-envelope-error');
          if (!$dimensionMessage.length) {
            $dimensionMessage = $('<div id="dimension-envelope-error" class="dimension-envelope-error" role="alert" aria-live="assertive"></div>');
            var $targetRow = $wid.closest('.var-grid').length ? $wid.closest('.var-grid') : $len.closest('.var-grid');
            $targetRow.after($dimensionMessage);
          }
          $dimensionMessage.text(message).addClass('is-visible');
          ok = false;
        } else {
          $('#dimension-envelope-error').removeClass('is-visible').empty();
        }
      }

      if (holesEnabled()){
        var $cnt = $('#num-holes');
        var $size = $('#hole-size');
        var $pos  = $('#hole-position');

        clearError($cnt); clearError($size); clearError($pos);

        var cnt = valOrEmpty('#num-holes');
        var size = valOrEmpty('#hole-size');
        var pos  = valOrEmpty('#hole-position');

        if (!/^\d+$/.test(cnt) || parseInt(cnt,10) <= 0){
          setError($cnt, 'Enter the number of holes.'); ok = false;
        }
        if (!size){ setError($size, 'Select a hole size.'); ok = false; }
        if (!pos){  setError($pos,  'Select a hole position.'); ok = false; }
      } else {
        // clear any previous errors on hole fields when not required
        ['#num-holes','#hole-size','#hole-position'].forEach(function(s){ clearError($(s)); });
      }

      // focus first error
      if (!ok){
        var $firstErr = $('.input-error').first();
        if ($firstErr.length) { $firstErr[0].scrollIntoView({behavior:'smooth', block:'center'}); $firstErr.focus(); }
      }
      return ok;
    }

    /* ---------- live cleanup on change ---------- */
    $(document).on('input change', '#length, #width, #num-holes, #hole-size, #hole-position, #drill-holes', function(){
      clearError($(this));

      if (this.id === 'length' || this.id === 'width') {
        var $dimensionInputs = $('#length, #width');
        var length = parseFloat($('#length').val());
        var width = parseFloat($('#width').val());
        var supportsRotation = $('#length[data-sheet-dimension-input]').length > 0 && $('#width[data-sheet-dimension-input]').length > 0;

        $dimensionInputs.removeClass('input-error').attr('aria-invalid', 'false');

        if (supportsRotation && isFinite(length) && length > 0 && isFinite(width) && width > 0) {
          var maxLength = Number(window.CP_CONF && window.CP_CONF.MAX_L) || 96;
          var maxWidth = Number(window.CP_CONF && window.CP_CONF.MAX_W) || 48;
          var invalidEnvelope = Math.max(length, width) > Math.max(maxLength, maxWidth)
            || Math.min(length, width) > Math.min(maxLength, maxWidth);

          if (invalidEnvelope) {
            $dimensionInputs.addClass('input-error').attr('aria-invalid', 'true');
          } else {
            $('#dimension-envelope-error').removeClass('is-visible').empty();
          }
        }
      }
    });

    $('#special-file').on('click', function(){ $('#prop-file').trigger('click'); });
    $('#prop-file').on('change', function(){
      const file = this.files[0];  
      if (file && file.size > 20 * 1024 * 1024) {  
        alert("File size must be less than 20 MB!");
        this.value = "";  
        return;
      }
      const name = this.files && this.files[0] ? this.files[0].name : 'No file chosen';
      $('.special-file-name').text(name);
    });

    /* ---------- add to cart with properties (blocks on invalid) ---------- */
    // OPTIONAL: reset helper (call from success + "clear all" button if you want)
      function resetConfigurator() {
        $('#length, #width').val('');
        $('#drill-holes').val('').trigger('change'); 
        $('#num-holes').val('0');
        $('#hole-size, #hole-position, #size').val('');
        $('#prop-file').val('');
        $('.qty_input').val(1);
        $('.special-file-name').text('');
        $('.finishlabel').find('input').prop('checked',false);
        $('.finishlabel').removeClass('selected');
        if (typeof toggleHoleFields === 'function') toggleHoleFields();
        if (typeof recalc === 'function') recalc(); 
        $('.qty__input').val(1)
        $('#w3review').val('')
      }

      

      $(document).on('click', '.product-form__submit', function (e) {
        
        if (typeof validateProductForm === 'function' && !validateProductForm()) {
          e.preventDefault();
          return false;
        }
        const L   = $('#length').val();
          const W   = $('#width').val();
          const rad = $('#size').val();
          const drill = $('#drill-holes').val();
          const holes = $('#num-holes').val();
          const hSize = $('#hole-size').val();
          const hPos  = $('#hole-position').val();
          const finish = $('input[name="finish"]:checked').map(function(){ return $(this).val(); }).get().join(' + ');
          const notes = $('#w3review').val();
  
          $('#prop-length').val(L ? `${L}"` : '');
          $('#prop-width').val(W ? `${W}"` : '');
          $('#prop-radius').val(rad || '');
          $('#prop-drill').val(drill || '');

          if (drill === 'yes') {
            $('#prop-holes').val(holes || '');
            $('#prop-holeSize').val(hSize || '');
            $('#prop-holePos').val(hPos || '');
            
          } else {
            $('#prop-holes, #prop-holeSize, #prop-holePos').val('');
          }
          $('#prop-notes').val(notes || '');
          $('#prop-finish').val(finish || '');
    
          $('#prop-total').val($('#totalPrice').attr('data-total'));  

        // $(this).parents('form').submit();
        
      });
      $(document).on('click', '.remove-btn', function(e){
        e.preventDefault();
        resetConfigurator();
        setTimeout(function(){
            resetConfigurator();
        },500);
      });
      document.addEventListener('resetCustomForm', () => {
          resetConfigurator();
          setTimeout(function(){
              resetConfigurator();
          },500);
      });
  })(jQuery);
 
}